// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Modal,
  Form,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  merchantDirectoryList
} from "../../../redux/actions/frontActions";
import {getSiteStatus}    from '../../../redux/actions/siteActions';
import noImg from "../../../img/no_img.jpg";
import noRecordFound from "../../../img/no-record-found.png";
import "react-responsive-tabs/styles.css";
import Timer from "./Timer";

import {
  FacebookShareButton,
  FacebookIcon,
  XIcon,
  TwitterShareButton,
} from 'react-share';

import ReactHtmlParser from "react-html-parser";
import Reviews from "./Reviews.js";
import Question from "./Question.js";
import ReviewList from "./ReviewList.js";
import Cookies from "universal-cookie";
import auth from "../../../services/auth";
import moment from "moment";
import { appConfig } from "../../../config";
import DatePicker from "react-date-picker";
import languageConfig from "../../../config/languageConfig";

const cookies = new Cookies();

let now = moment();

const history = createBrowserHistory();
let isLoading = false,
  limit = 24;
function Currency(props) { 
  const cur = props.default_currency == 'EUR' ? '€' : '$';
  return <span className={props.className} >{props.default_lang=='en' ? cur : ''}{props.amount}{props.default_lang=='fr' ? cur : ''}</span>;
}
class MerchantDirectory extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      merchantDir: [],
      limit: 24,
      perPage: 24,
      total: "",
      button_color: '',
      text_color: "",
      mouseover_color: '',
      default_city: "",
      siteDomain: "",
      wdith: 0,
      height: 0,
      notifications: '',
      sending: false,
      notFoundPopup: false,
      removePopup: true,
      hover: false,
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      load_more: false,
      currency: '',
      symbol: '',
      NoRecord:'',
      siteName:'',
      fb_link:''
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.pagination = this.pagination.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }
 
  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if(/^(:\/\/)/.test(newUrl)){
      return `http${newUrl}`;
    }
    if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
        return `http://${newUrl}`;
      }

      return newUrl;
    }

  closenotFoundPopup = () => {
    this.setState({removePopup: false, total: ''});
  }
  pagination = () => {
    // isLoading = true;
    this.setState({load_more: true});
    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      cityID : this.state.default_city,
      geolocation: "off",
      lang: this.state.default_lang,
      default_lang:this.state.default_lang,
    };

    this.props.merchantDirectoryList(postData);
  }; 
  

  handlePageChange = page => {
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true
    });
    let default_city = this.state.default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          siteName: siteData.siteName,
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,

        });
        default_city = siteData.default_city;
      }
    }
    
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
    };

    if(default_city){
 
      postData.cityID = (cookies.get('akash') ? cookies.get('akash') : default_city);
    }
    if(siteData && siteData.default_lang){
      //postData.lang= siteData.default_lang;
    }
    if(!isEmpty(this.props.match.params) && this.props.match.params.cityID){
      postData.geolocation = "off";
    }
    
    if(this.state.geoCityId != this.state.default_city){
      //akash
      postData.geolocation = "off";
    }

     postData.lang = this.state.default_lang,
        postData.default_lang = this.state.default_lang

    this.props.merchantDirectoryList(postData);
  };

  onSearch = val => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      latitude: this.props.coords ? this.props.coords.latitude : "26.846695",
      longitude: this.props.coords ? this.props.coords.longitude : "80.946167",
      search: val,
      geolocation: "off",
      lang: this.sate.default_lang,
      cityID: this.state.default_city
    };
    if (val.length !== 0) {
      this.props.merchantDirectoryList(postData);
    } else {
      this.handlePageChange();
    }
  }
  componentWillMount(){
    isLoading = true;
    if(this.props.match.params && this.props.match.params.cityID){      
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      // siteData.default_city = this.props.match.params.cityID;
      //localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
      this.setState({
        default_city: this.props.siteStatus.default_city,//this.props.match.params.cityID,
      });     
    }    
  }
  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({siteDomain: siteData.siteDomain});
      if(siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          geoCityId: (siteData.country && siteData.country.default_geo_city) ? siteData.country.default_geo_city : '',
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
          siteName: siteData.siteName,
        });
      }
    }else{
      // this.props.getSiteStatus();
    }
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          text_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
      if(siteData.default_lang=='fr') {
        this.setState({NoRecord: this.props.themeData.french_NoRecord});
      } else {
        this.setState({NoRecord: this.props.themeData.NoRecord});
      }
      this.setState({fb_link: this.props.themeData.fb_link});
    }
    this.handlePageChange(1);
    let userIDParams = this.props.match.params.user_ID
      ? this.props.match.params.user_ID
      : "";
    let Link = this.props.match.url;
    if (userIDParams !== "") {
      const token = auth.getToken();
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);

      cookies.set("referredBy", userIDParams, { path: "/", expires: d });

      let url = appConfig.site.siteurl;
      cookies.set("referredLink", url + "" + Link, { path: "/", expires: d });
      let referredLink = cookies.get("referredLink");

      this.context.router.history.push({ pathname: "/" });

      if (token !== null) {
        let d = new Date();
        d.setTime(d.getTime() + 480 * 60 * 1000);
      }
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if(this.props.themeData.menu_bar){
      this.setState({
        menuBgStyles: {
          backgroundColor: this.props.themeData.menu_bar.menu_bar_color
        }
      })
    }else{
      this.setState({
        menuBgStyles: {
          backgroundColor: ''
        }
      })
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleLanguageChange(lang){
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true
    });
    let default_city = this.state.default_city;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          siteName: siteData.siteName,
        });
        default_city = siteData.default_city;
      }
    }
    
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
    };

    if(default_city){
      postData.cityID = default_city;
    }
    if(this.state.default_lang){
      postData.lang= lang;
    }
    if(!isEmpty(this.props.match.params) && this.props.match.params.cityID){
      postData.geolocation = "off";
    }
    
    if(this.state.geoCityId != this.state.default_city){
      postData.geolocation = "off";
    }

    this.props.merchantDirectoryList(postData);

  }

  componentWillReceiveProps(nextProps) {
    let lang = this.state.default_lang ? this.state.default_lang : 'en'; 
    if(this.props.match.params && this.props.match.params.cityID && this.state.default_city){
      if(this.props.match.params.cityID != this.state.default_city){
        isLoading = true;
      }
    }
    
    if(nextProps.language){
      if(this.state.default_lang !== nextProps.language){
        lang = nextProps.language;
        isLoading = true;
        this.setState({default_lang: nextProps.language});
        this.handleLanguageChange(nextProps.language);
      }
    }
    if(nextProps.currency){ 
      this.setState({currency: nextProps.currency, symbol: nextProps.symbol})
    }
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    if(siteData){
      this.setState({
        notifications: siteData.notifications, 
        siteName: siteData.siteName,
      });
    }
    // this.setState({sending: nextProps.sending});
    if(nextProps.match.params && nextProps.match.params.cityID && nextProps.match.params.cityID.length > 0  && nextProps.match.params.cityID != this.state.default_city){
      this.setState({
        default_city: nextProps.match.params.cityID
      });
      this.handlePageChange(1);
    }

    if((this.props.siteStatus != nextProps.siteStatus) && this.state.default_city == '' ){
      if(nextProps.siteStatus){
          this.handlePageChange(1);
      }
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
      if(lang=='fr') {
        this.setState({NoRecord: nextProps.themeData.french_NoRecord});
      } else {
        this.setState({NoRecord: nextProps.themeData.NoRecord});
      }
      this.setState({fb_link: nextProps.themeData.fb_link});
    }

    if(nextProps.themeData.menu_bar){
      this.setState({
        menuBgStyles: {
          backgroundColor: nextProps.themeData.menu_bar.menu_bar_color
        }
      })
    }else{
      this.setState({
        menuBgStyles: {
          backgroundColor: ''
        }
      })
    }
    if ((this.props.merDirectory != nextProps.merDirectory)  && this.state.default_city !== '') {
      isLoading = true;
      this.setState({ total: (nextProps.merDirectory.total) ? nextProps.merDirectory.total : 0, notFoundPopup: false });
      this.setState({ merDirectory: nextProps.merDirectory.data });
      if(nextProps.merDirectory && nextProps.merDirectory.data && nextProps.merDirectory.data.length > 0){
        let topMerchants = nextProps.merDirectory.data[0];
        this.setState({ topMerchant: topMerchants, notFoundPopup: false, load_more: false, sending: false });
        isLoading = false;
      }else{
        this.setState({
          merDirectory: '',
          topMerchant: '',
          removePopup: true,
          sending: false
        });
        isLoading = false;
      }
    }else{
      if(isEmpty(nextProps.merDirectory)){
        this.setState({
          merDirectory: '',
          topMerchant: '',
          removePopup: true,
          sending: false
        })
        isLoading = false;
      } else if(nextProps.merDirectory && this.props.merDirectory == nextProps.merDirectory && nextProps.sending == true){
        isLoading = true;
        this.setState({ total: (nextProps.merDirectory.total) ? nextProps.merDirectory.total : 0, notFoundPopup: false });
        this.setState({ merDirectory: nextProps.merDirectory.data });
        if(nextProps.merDirectory && nextProps.merDirectory.data && nextProps.merDirectory.data.length > 0){
          let topMerchants = nextProps.merDirectory.data[0];
          this.setState({ topMerchant: topMerchants, notFoundPopup: false, load_more: false, sending: false });
          isLoading = false;
        }else{
          this.setState({
            merDirectory: '',
            topMerchant: '',
            removePopup: true,
            sending: false
          });
          isLoading = false;
        }
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        isLoading = false;
      }
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    if ((this.state.merDirectory === nextState.merDirectory) && this.state.removePopup === false) {
        return false
    }
    return true
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }

  render() { 
    const { index, direction, notifications, width} = this.state;
    const isMobile = width >= 600;
    let merchantDir, totalMerchant, utotalMerchant, position;


    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    if (!isEmpty(this.state.merDirectory)) {
      totalMerchant = this.state.merDirectory.length;
        
      merchantDir = this.state.merDirectory.map((merchant, index) => {
          return <React.Fragment key={Math.random() + index}>
            <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
              <div className="deal-container merchant-directory shadow">
                <div className="deal-image">
                  <Link
                    key={Math.random()}
                    to={(merchant.merchantID) ? `/store/${merchant.merchantID}` : `/store/${merchant.merchantID}-${merchant.merchantName.toLowerCase().trim().split(/\s+/).join('-')}/${this.state.default_city}`}
                  >  
                    <Image
                      src={ !isEmpty(merchant.merchant_logo) ? merchant.merchant_logo : noImg }
                      responsive
                    />
                  </Link>
                </div>
                <div className="merchant-social-icon">
                  <h2 className="dealname merchant-name">
                    {ReactHtmlParser((merchant.merchantName != '') ? merchant.merchantName : merchant.legalName)}
                  </h2>        
                  <div className="social-icons">
                    {(merchant.facebookPage) ?
                      <a className="facebook" href={(merchant.facebookPage) ? merchant.facebookPage : ""} target="_blank">
                      <FacebookIcon size={25} round={false} />
                      </a>
                      :""
                    }
                    {(merchant.twitterPage) ? 
                      <a className="twitter" href={(merchant.twitterPage) ? merchant.twitterPage : ""} target="_blank">
                      <XIcon size={25} round={false} />
                      </a>
                      :""
                    }
                  </div> 
                </div>        
                <div className="short-disc">
                  {!isEmpty(merchant.storefrontUrl)
                    ? <a href={this.state.siteDomain + '/store/' + merchant.storefrontUrl} target="_blank">{this.state.siteDomain + '/store/' + merchant.storefrontUrl}</a>
                    : ""}                    
                </div>
                <div className="deal-footer">
                  {(isIE == false && isEdge == false && isMobile) ?
                    <Link
                    className="btn btn-deal" 
                    data-id = {merchant.merchantID}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == merchant.merchantID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                    key={Math.random()}
                    to={(merchant.merchantID) ? `/store/${merchant.merchantID}` : `/store/${merchant.merchantID}-${merchant.merchantName.toLowerCase().trim().split(/\s+/).join('-')}/${this.state.default_city}`} > 
                        {languageConfig[this.state.default_lang].view}
                    </Link>
                    :
                    <Link
                    className="btn btn-deal" 
                    data-id = {merchant.merchantID}
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == merchant.merchantID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                    key={Math.random()}
                    to={(merchant.merchantID) ? `/store/${merchant.merchantID}` : `/store/${merchant.merchantID}-${merchant.merchantName.toLowerCase().trim().split(/\s+/).join('-')}/${this.state.default_city}`} > 
                        {languageConfig[this.state.default_lang].view}
                    </Link>
                  }
                </div>
              </div>
            </Col> 
          </React.Fragment>

      });
    }

    return (
      <div>
        {(this.state.sending == true || isLoading == true) ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {!isEmpty(this.state.topMerchant) && isLoading != true ? (
        <React.Fragment>
          <div className="container">
            <Row className="dealflex">
              {merchantDir}
            </Row>
            
            {this.state.total > totalMerchant ? (
              <Row>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  onClick={this.pagination}
                  className="text-center"
                >
                  <a 
                  className="btn btn-deal" 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {'Load More'}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  >
                  {(this.state.load_more) ?
                  <React.Fragment> 
                  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> {languageConfig[this.state.default_lang].load_more_deals}
                  </React.Fragment> 
                  :
                  languageConfig[this.state.default_lang].load_more_deals
                  } 
                  </a>
                </Col>
              </Row>
            ) : null}
          </div> 
        </React.Fragment>
        ):('')}
        
        {isEmpty(this.state.topMerchant) && isLoading != true ? (
          <React.Fragment>
          <Row>
            <Col lg={12} md={1} sm={12} xs={12}>
              <Image src={this.state.NoRecord ? this.state.NoRecord : noRecordFound} responsive style={{margin: 'auto'}}/>
            }
            </Col>
          </Row>
          </React.Fragment>
        ):('')}
      </div>
    );
  }
}

// export default MerchantDirectory;

MerchantDirectory.propTypes = {
  merchantDirectoryList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  merDirectory: state.frontReducer.merDirectory,
  error: state.frontReducer.error,
  sending: state.frontReducer.sending,
  siteStatus: state.siteReducer.siteStatus,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    merchantDirectoryList, getSiteStatus
  })
)(MerchantDirectory);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/MerchantDirectory.js